import React, { useState, useEffect, useMemo } from "react";
import Menu from "../../../components/layout/menu/index"
import { format } from 'date-fns';
import ModalWarning from "../../../components/shared/modals/modalWarning/index"
import ModalRemainingDocuments from "../../../components/shared/modals/modalRemainingDocuments/index"
import IndicatorGauge from "../../../components/dashboards/radialBarChart";
import PieChartOrders from "../../../components/dashboards/pieChart";
import DeliveryAverageChart from "../../../components/dashboards/deliveryAverageChart";
import PieChartBilling from "../../../components/dashboards/billingChart";
import ModalSuccess from "../../../components/shared/modals/modalSuccess";
import ModalSurveysCount from "../../../components/shared/modals/modalSurveysCount";
import ListFilter from "../../../components/filters/listFilters";
import { useModuleAdherence } from "../../../hooks/userAdherence";
import { axiosInstance } from '../../../client';
import { useAuth } from '../../../context/auth';
import AdHomeModal from "../../../components/announcements/AdHomeModal";
import BarChartData from "../../../components/dashboards/barChart";
import { getPendingDelivery, getAverageDeliveryDays, getComplianceIndicator, getQuantityMaterialOrders, getBilling } from "../../../client/purchaseOrder";
import { getHesEvaluation, getSupplierPosition } from "../../../client/evaluation";
import { getDocumentsRemaining } from "../../../client/seasonDocumentSuppliers";
import { getCountSurveysToUser } from "../../../client/surveys";
import { MODALS } from "../../../config/images";
import BarChartATC from "../../../components/dashboards/barChartATC";
import { getAtcDashboardData, getCountEmptyAtcs } from "../../../client/atc/index"
import AtcVaciasChart from "../../../components/dashboards/atcVaciasChart";
export default function Home() {
  const { categorySupplier, supplierId } = useAuth();
  useModuleAdherence(4);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [showModalWarning, setShowModalWarning] = useState(
    sessionStorage.getItem('hasShownContractModal') !== 'true'
  );
  const [showHomologationWarning, setShowHomologationWarning] = useState(
    sessionStorage.getItem('hasShownHomologationModal') !== 'true'
  );

  const [showContactModal, setShowContactModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { user } = useAuth();
  const roleId= user?.roleId;
  const criticity = user.supplierCriticity;
  const [supplier, setSupplier] = useState(null);
  const [pendingDelivery, setPendingDelivery] = useState([]);
  const [activeAds, setActiveAds] = useState([]);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);
  const [showAdModal, setShowAdModal] = useState(false);
  const [isAdOpen, setIsAdOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [homologationDate, setHomologationDate] = useState(null);
  const [hesEvaluation, setHesEvaluation] = useState(0);
  const [deliveryAverages, setDeliveryAverages] = useState(null);
  const [complianceIndicator, setComplianceIndicator] = useState(0);
  const [quantityMaterialOrders, setQuantityMaterialOrders] = useState(null);
  const [billing, setBilling] = useState(null);
  const [supplierPosition, setSupplierPosition] = useState(null);

  const [loadingCompliance, setLoadingCompliance] = useState(true);
  const [loadingHes, setLoadingHes] = useState(true);
  const [loadingDeliveryAverages, setLoadingDeliveryAverages] = useState(true);
  const [loadingQuantityMaterial, setLoadingQuantityMaterial] = useState(true);
  const [loadingBilling, setLoadingBilling] = useState(true);

  const [showModalRemaining, setShowModalRemaining] = useState(
    sessionStorage.getItem('hasShowRemainingModal') !== 'true'
  );
  const [seasonsLeft, setSeasonsLeft] = useState('');

  const [countNotResponded, setCountNotResponded] = useState(0);
  const [userName, setUserName] = useState('');

  const [atcData, setAtcData] = useState(null);
  const [loadingAtc, setLoadingAtc] = useState(true);
  const [atcChartData, setAtcChartData] = useState([]);

const [emptyAtcCountData, setEmptyAtcCountData] = useState({
  totalEmptyAtcs: 0,
  startDate: '',
  endDate: ''
});
const [loadingAverageEmptyAtc, setLoadingAverageEmptyAtc] = useState(true);

const getDefaultDateRange = () => {
  const today = new Date();
  const twelveMonthsAgo = new Date();
  twelveMonthsAgo.setMonth(today.getMonth() - 12);
  
  return {
    startDate: format(twelveMonthsAgo, 'yyyy-MM-dd'),
    endDate: format(today, 'yyyy-MM-dd')
  };
};
const [activeDates, setActiveDates] = useState(getDefaultDateRange());
const [tempDates, setTempDates] = useState(getDefaultDateRange());

const fetchEmptyAtcCountData = async () => {
  try {
    setLoadingAverageEmptyAtc(true);
    
    const startDate = activeDates?.startDate || null;
    const endDate = activeDates?.endDate || null;
    
    const currentSupplierId = supplierId;
    
    const supplierIds = currentSupplierId ? [currentSupplierId] : null;
    
    const data = await getCountEmptyAtcs(startDate, endDate, supplierIds, null);
    setEmptyAtcCountData(data);
  } catch (err) {
    console.error('Error fetching empty ATC count data:', err);
    setEmptyAtcCountData({
      totalEmptyAtcs: 0,
      startDate: '',
      endDate: ''
    });
  } finally {
    setLoadingAverageEmptyAtc(false);
  }
};

useEffect(() => {
  fetchEmptyAtcCountData();
}, [supplierId, activeDates]); 



  const fetchAtcDashboardData = async () => {
    try {
      setLoadingAtc(true);

      const dashboardData = await getAtcDashboardData(supplierId);
      setAtcData(dashboardData);
      
      const chartData = dashboardData.monthlyData.map(item => ({
        mes: item.month,
        emptyATC: item.emptyATC,
        rejectedATC: item.rejectedATC
      }));
      
      setAtcChartData(chartData);
    } catch (err) {
      console.error('Error fetching ATC dashboard:', err);
    } finally {
      setLoadingAtc(false);
    }
  };

  useEffect(() => {
      fetchAtcDashboardData();
  }, [supplierId]);

  const closeModal = () => {
    setShowModalWarning(false);
    sessionStorage.setItem('hasShownContractModal', 'true');
  };

  const closeHomologationModal = () => {
    setShowHomologationWarning(false);
    sessionStorage.setItem('hasShownHomologationModal', 'true');
  };

  const closeRemainingModal = () => {
    setShowModalRemaining(false);
    sessionStorage.setItem('hasShowRemainingModal', 'true');
  };

  const [showModalSurveysCount, setShowModalSurveysCount] = useState(
    sessionStorage.getItem('hasShowModalSurveysCount') !== 'true'
  );

  const closeSurveysCountModal = () => {
    setShowModalSurveysCount(false);
    sessionStorage.setItem('hasShowModalSurveysCount', 'true');
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [filterOptions, setFilterOptions] = useState([
    {
      title: "Rango de fechas:",
      type: "dateRange"
    },
  ]);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); 
    if (value.length <= 9) {
      const formatted = value.replace(/(\d{3})(\d{0,3})(\d{0,3})/, (_, p1, p2, p3) =>
        [p1, p2, p3].filter(Boolean).join(' ')
      );
      setPhoneNumber(formatted);
    }
  };

  const fetchAndSetAds = async (userId) => {
    const { data: ads } = await axiosInstance.get(
      `/Advertisement/ActiveByUser/${userId}`
    );
    if (ads.length) {
      setActiveAds(ads);
      setShowAdModal(true);
    }
    return ads;
  };

const safeStr = (v) => (v === null || v === undefined || v === '' ? '-' : String(v));
const joinAddress = (s) =>
  [s?.street, s?.district, s?.region].filter(Boolean).join(', ') || '-';
const formatPhone = (raw) => {
  if (raw === null || raw === undefined || raw === '') return '-';

  const s = String(raw).trim();
  const hasPlus = s.startsWith('+');        
  const digits = s.replace(/\D/g, '');     

  if (!digits) return '-';

  const grouped = (digits.match(/.{1,3}/g)?.join(' ') || digits).trim();

  return hasPlus ? `+${grouped}` : grouped;
};

const fetchAndSetSupplier = async (authUserId) => {
  try {
    const { data } = await axiosInstance.get(`/User/${authUserId}/supplier`);
    const apiUser = data?.user ?? {};
    const sup     = data?.supplier ?? {};

    const supplierUI = {
      id: sup?.id ?? null,
      name: safeStr(sup?.name),
      ruc: safeStr(sup?.ruc ?? sup?.code),
      code: safeStr(sup?.code),
      email: safeStr(sup?.email),                 
      category: safeStr(apiUser?.category),       
      address: joinAddress(sup),                  
      phone: formatPhone(apiUser?.contact_number),
      criticity: safeStr(sup?.criticity),
      homologationDate: sup?.homologation_date ?? null,
    };

    setSupplier(supplierUI);
    setPhoneNumber(supplierUI.phone);
    setHomologationDate(supplierUI.homologationDate);
    return sup?.id ?? null;
  } catch (e) {
    const supplierUI = {
      id: user?.supplierId ?? null,
      name: safeStr(user?.supplierName ?? user?.name),
      ruc: safeStr(user?.supplierCode),
      code: safeStr(user?.supplierCode),
      email: safeStr(user?.email),
      category: safeStr(user?.category),              
      address: '-',
      phone: formatPhone(user?.contact_number),       
      criticity: safeStr(user?.supplierCriticity),
      homologationDate: null,
    };
    setSupplier(supplierUI);
    setPhoneNumber(supplierUI.phone);
    setHomologationDate(null);
    return supplierUI.id;
  }
};


  useEffect(() => {
    const fetchData = async () => {
      if (!categorySupplier || !supplierId) return;
      try {
        const posResp = await getSupplierPosition(categorySupplier, supplierId);
        setSupplierPosition(posResp.data);
      } catch (err) {
        console.error('Error fetching benefits:', err);
      }
    };

    fetchData();
  }, [categorySupplier, supplierId]);





  const fetchHesEvaluation = async () => {
    try {
      setLoadingHes(true);
      const hesResp = await getHesEvaluation(supplierId);
      setHesEvaluation(hesResp.data?.value);
    } catch (err) {
      console.error('Error fetching HES evaluation:', err);
    } finally {
      setLoadingHes(false);
    }
  }

  const fetchAverageDelivery = async () => {
    try {
      setLoadingDeliveryAverages(true);
      const avgResp = await getAverageDeliveryDays(supplierId);
      setDeliveryAverages(avgResp?.data?.delays);
    } catch (err) {
      console.error('Error fetching delivery averages:', err);
    } finally {
      setLoadingDeliveryAverages(false);
    }
  }

  const fetchComplianceIndicator = async () => {
    try {
      setLoadingCompliance(true);
      const avgResp = await getComplianceIndicator(
        supplierId, null, activeDates?.startDate, activeDates?.endDate
      );
      setComplianceIndicator(avgResp?.data?.percentage);
    } catch (err) {
      console.error('Error fetching compliance indicator:', err);
    } finally {
      setLoadingCompliance(false);
    }
  }

  const fetchQuantityMaterial = async () => {
    try {
      setLoadingQuantityMaterial(true);
      const qtyResp = await getQuantityMaterialOrders(
        supplierId, null, activeDates?.startDate, activeDates?.endDate
      );
      setQuantityMaterialOrders(qtyResp?.data);
    } catch (err) {
      console.error('Error fetching delivery averages:', err);
    } finally {
      setLoadingQuantityMaterial(false);
    }
  }

  const fetchBilling = async () => {
    try {
      setLoadingBilling(true);
      const billResp = await getBilling(
        supplierId, null, activeDates?.startDate, activeDates?.endDate
      );
      setBilling(billResp?.data);
    } catch (err) {
      console.error('Error fetching billing:', err);
    } finally {
      setLoadingBilling(false);
    }
  }

  useEffect(() => {
    if (!supplierId) return;
    fetchHesEvaluation();
    fetchAverageDelivery();
  }, [supplierId]);

  useEffect(() => {
    if (!supplierId) return;
    fetchComplianceIndicator();
    fetchQuantityMaterial();
    fetchBilling();
  }, [supplierId, activeDates]);

useEffect(() => {
  const defaultDates = getDefaultDateRange();
  setActiveDates(defaultDates);
  setTempDates(defaultDates);
}, []);

const applyFilters = () => {
  const newActiveDates = {
    startDate: tempDates?.startDate || getDefaultDateRange().startDate,
    endDate: tempDates?.endDate || getDefaultDateRange().endDate,
  };
  setActiveDates(newActiveDates);
};

  const handleDateRangeChange = ({ startDate, endDate }) => {
    setTempDates({
      startDate,
      endDate,
    });
  };


  const { daysLeft, formattedDate } = useMemo(() => {
    if (!homologationDate) return { daysLeft: 0, formattedDate: '' };

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const target = new Date(`${homologationDate}T00:00:00-05:00`);
    target.setHours(0, 0, 0, 0);

    const diffMs = target - today;
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    const opts = { day: 'numeric', month: 'long', year: 'numeric' };
    const formatted = target.toLocaleDateString('es-PE', opts);

    return { daysLeft: days, formattedDate: formatted };
  }, [homologationDate]);

  const getInitials = (name) => {
    if (!name) return '--';
    const words = name.split(' ');
    return words
      .slice(0, 2)
      .map(word => word[0]?.toUpperCase() || '')
      .join('');
  };

const supplierIdFromState = supplier?.id ;


const handleSubmit = async () => {
  setShowContactModal(false);
  setLoading(true);
  try {
    const digits = String(phoneNumber).replace(/\s/g, '');
    const contactNumber = parseInt(digits, 10);

    await axiosInstance.put(`/User/${user.id}/contact-number`, { contactNumber });
    
    await fetchAndSetSupplier(user.id);

    setShowSuccessModal(true);
  } catch (err) {
    console.error('Error actualizando el número del supplier:', err);
  } finally {
    setLoading(false);
  }
};

const fetchDocumentsRemaining = async (supplierIdToUse) => {
  try {
    const seasons = await getDocumentsRemaining(supplierIdToUse);
    
    const formatSeasonsList = (seasons) => {
      if (!seasons || seasons.length === 0) return '';
      
      const seasonNames = seasons.map(s => `temporada "${s.seasonName}"`);
      
      if (seasonNames.length === 1) {
        return seasonNames[0];
      } else if (seasonNames.length === 2) {
        return seasonNames.join(' y ');
      } else {
        const allNames = seasonNames;
        const last = allNames.pop(); 
        return `${allNames.join(', ')} y ${last}`;
      }
    };
    
    const seasonsFormatted = formatSeasonsList(seasons);
    
    if (seasonsFormatted) {
      setSeasonsLeft(seasonsFormatted); 
      setShowModalRemaining(true);
    } else {
      setShowModalRemaining(false);
    }
  } catch (err) {
    console.error('Error al obtener temporadas con documentos pendientes:', err);
    setShowModalRemaining(false);
  }
};

const fetchPendingSurveys = async (userId) => {
  try {
    const response = await getCountSurveysToUser(userId);
    const data = response.data;
    if (data?.countNotResponded > 0) {
      setCountNotResponded(data.countNotResponded);
      setUserName(data.userName);
      setShowModalSurveysCount(true);
    } else {
      setShowModalSurveysCount(false);
    }
  } catch (err) {
    console.error('Error al obtener documentos restantes:', err);
    setShowModalSurveysCount(false);
  }
};

useEffect(() => {
  if (user?.id) {
    fetchPendingSurveys(user.id);
  }
}, [user?.id]);

useEffect(() => {
  if (!user || user.role !== 'Proveedor') return;

  const loadAll = async () => {
    setLoading(true);
    try {
      const [_, supId] = await Promise.all([
        fetchAndSetAds(user.id),
        fetchAndSetSupplier(user.id), 
      ]);

      const supplierIdToUse = supId ?? user?.supplierId ?? supplierId ?? null;

      if (supplierIdToUse) {
        const { data: pending } = await getPendingDelivery(supplierIdToUse);
        setPendingDelivery(Array.isArray(pending) ? pending : (pending?.items ?? []));
        await fetchDocumentsRemaining(supplierIdToUse);
      } else {
        setPendingDelivery([]);
      }
    } catch (err) {
      console.error('Error al cargar datos:', err);
      setPendingDelivery([]);
    } finally {
      setLoading(false);
    }
  };

  loadAll();
}, [user?.id]);




  useEffect(() => {
    if (activeAds?.length) {
      setIsAdOpen(true);
      setCurrentAdIndex(0);
    }
  }, [activeAds]);

  const handleClose = () => {
    if (currentAdIndex + 1 < activeAds.length) {
      setCurrentAdIndex(i => i + 1);
    } else {
      setIsAdOpen(false);
    }
  };

const openContactModal = () => {
  setPhoneNumber(supplier?.phone && supplier.phone !== '-' ? supplier.phone : '');
  setShowContactModal(true);
};

  if (loading) {
    return (
      <div>
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
        <div className={`flex-1 transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} pt-[67px] bg-[#F7F8F9] w-full z-50 min-h-screen`}>
          <div className="pt-4 pb-10 px-[3%] flex flex-col gap-4">
            <div className="flex items-center justify-center h-screen">
              <div className="w-8 h-8 border-4 border-gray-200 rounded-full animate-spin border-t-blue-600"></div>
            </div>
          </div>
        </div>
      </div>
    )
  }



  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} pt-[67px] bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%] flex flex-col gap-4">
          <div className="w-full  bg-[#5CBDEB] bg-opacity-30 p-6 rounded-2xl">
            <h1 className="text-blue text-center break-words lg:text-left font-itcbold text-[32px]">
              Bienvenido, {supplier?.name || ''}
            </h1>
            <div className="flex flex-col items-center gap-4 pt-2 lg:flex-row md:pt-6 sm:gap-6 ">
              {/* <div className="flex items-center justify-center">
                <img src={imageHome} alt="imageHome" className="w-full rounded-2xl" />
              </div> */}
              <div className="sm:w-64 w-52 aspect-square flex items-center justify-center border-[4px] border-[#D9D9D9] text-white bg-[#5CBDEB] rounded-full ">
                <p className="text-[42px] font-itcbold">
                  {getInitials(supplier?.name)}
                </p>
              </div>
              <div className="grid grid-cols-1 gap-5">
                <div className="grid gap-5 md:grid-cols-3">
                  <div className="flex flex-col gap-3">
                    <h2 className="text-[18px] text-blue break-words font-itcdemi">Correo coorporativo</h2>
                    <p className="text-base break-words font-itcbook text-blue-dark">{safeStr(supplier?.email)}</p>
                  </div>
                  <div className="flex flex-col gap-3">
                    <h2 className="text-[18px] break-words text-blue font-itcdemi">Categoría</h2>
                    <p className="text-base break-words font-itcbook text-blue-dark">{safeStr(supplier?.category)}</p>
                  </div>
                  <div className="flex flex-col gap-3">
                    <h2 className="text-[18px] break-words text-blue font-itcdemi">Dirección</h2>
                    <p className="text-base break-words font-itcbook text-blue-dark">{safeStr(supplier?.address)}</p>
                  </div>
                </div>
                <div className="grid gap-5 md:grid-cols-3">
                  <div className="flex flex-col gap-3">
                    <h2 className="text-[18px] break-words text-blue font-itcdemi">RUC</h2>
                    <p className="text-base break-words font-itcbook text-blue-dark">{safeStr(supplier?.ruc)}</p>
                  </div>
                  <div className="flex flex-col gap-3">
                    <h2 className="text-[18px] break-words text-blue font-itcdemi">Razón social</h2>
                    <p className="text-base break-words font-itcbook text-blue-dark">{safeStr(supplier?.name)}</p>
                  </div>
                  <div className="flex flex-col gap-3">
                    <h2 className="text-[18px] break-words text-blue font-itcdemi">Contacto</h2>
                    <div className="flex items-center gap-2">
                      <p className="text-base break-words font-itcbook text-blue-dark">{supplier?.phone ?? '-'}</p>
                      <button onClick={openContactModal}>
                        <svg className="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 18.9998H6.425L16.2 9.2248L14.775 7.7998L5 17.5748V18.9998ZM3 20.9998V16.7498L17.625 2.1748L21.8 6.4498L7.25 20.9998H3ZM15.475 8.5248L14.775 7.7998L16.2 9.2248L15.475 8.5248Z" fill="#007696" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {homologationDate && daysLeft >= 0 && (
            <div className="flex items-center p-2 px-5 rounded-lg bg-[#FCB42F]">
              <p className="text-white font-itcmedium sm:text-[1.7vw] text-[3.7vw]">
                Tu homologación está por vencer. Te quedan <strong>{daysLeft}</strong> días para actualizarla.
                Hazlo 
                <a href="mailto:operacionesdecompra@tasa.com.pe" className="text-[#6A57FF]">
                  {' '}aquí
                </a>
              </p>
            </div>
          )}
          {homologationDate && daysLeft < 0 && (
            <div className="flex items-center p-2 px-5 rounded-lg bg-[#BD002A]">
              <p className="text-white font-itcmedium sm:text-[1.7vw] text-[3.7vw]">
                Tu homologación venció hace <strong>{Math.abs(daysLeft)}</strong> días.
                Actualícela 
                <a href="mailto:operacionesdecompra@tasa.com.pe" className="text-[#6A57FF]">
                  {' '}aquí
                </a>
              </p>
            </div>
          )}
          <h2 className="text-blue flex  text-[32px] font-itcbold">Dashboard</h2>
          {supplierPosition && (
            <p className="text-blue font-itcmedium text-[24px]">
              Te encuentras en el puesto {''}
              <span className="text-[#769B40] font-itcbold">
                #{supplierPosition.position} {''}
              </span>
              - tu puntaje es de {''}
              <span className="text-[#769B40] font-itcbold">
                {supplierPosition.score}% de 100%
              </span>
            </p>
          )}
                  
          <BarChartData
            title="Pendientes de entrega"
            chartTitle=""
            xAxisDataKey="month"
            tooltipLabelFormatter={month => `Mes: ${month}`}
            height={277}
            bars={[
              { dataKey: 'newCount', name: 'Posiciones con fecha de entrega a Tiempo', fill: '#769B40', label: false },
              { dataKey: 'pendingCount', name: 'Posiciones con fecha de entrega por vencer', fill: '#FFC000', label: false },
              { dataKey: 'expiredCount', name: 'Posiciones con fecha de entrega vencida', fill: '#BD002A', label: false }
            ]}
            data={pendingDelivery}
            showLegend={true}
            barGap={6}
            barCategoryGap="15%"
          />

          <BarChartATC
            title="Indicador de ATC"
            chartTitle=""
            xAxisDataKey="mes"
            tooltipLabelFormatter={mes => `Mes: ${mes}`}
            height={300}
            bars={[
              { 
                dataKey: 'emptyATC', 
                name: 'ATC Vacías', 
                fill: '#58B6E5', 
                label: true 
              },
              { 
                dataKey: 'rejectedATC', 
                name: 'ATC Rechazadas', 
                fill: '#BD002A', 
                label: true 
              }
            ]}
            data={atcChartData}
            showLegend={true}
            barGap={8}
            barCategoryGap="15%"
            loading={loadingAtc}
            atcSummary={atcData}
          />
          
          <div className="flex justify-end w-full">
            {/* <button className="text-[#52526C] cursor-pointer w-[151px] h-[35px] rounded-lg font-itcmedium text-[2.5vw] sm:text-[1vw] border-blue-light border-[1px]">
              Filtrar por tiempo
            </button> */}
            <ListFilter
              titleOption="Filtrar por tiempo"
              filters={filterOptions}
              widthPx={151}
              onDateRangeChange={handleDateRangeChange}
              applyFilters={applyFilters}
              position="right-0"
            />
          </div>
          <div className="grid items-start grid-cols-1 gap-4 md:grid-cols-3 ">
            <IndicatorGauge
              value={complianceIndicator}
              title="Indicador de cumplimiento de Materiales"
              description="Tu nivel de cumplimiento es de"
              color="#007696"
              loading={loadingCompliance}
            />
            <IndicatorGauge
              value={hesEvaluation}
              title="Indicador de HES de Servicios"
              description="Tu nivel de cumplimiento es de"
              color="#769B40"
              loading={loadingHes}
            />

            <AtcVaciasChart
              vaciasCount={emptyAtcCountData.totalEmptyAtcs} 
              loading={loadingAverageEmptyAtc}
            />

          </div>

          <div className="grid items-start grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <PieChartOrders
              delivered={quantityMaterialOrders?.deliveredPercentage}
              pending={quantityMaterialOrders?.pendingPercentage}
              expired={quantityMaterialOrders?.expiredPercentage}
              loading={loadingQuantityMaterial}
              roleId={roleId}
            />
            <PieChartBilling
              delivered={billing && billing.billed}
              pending={billing && billing.pending}
              loading={loadingBilling}
            //expired={10}
            />
            <DeliveryAverageChart
              averageDays={deliveryAverages && deliveryAverages[0]?.average}
              previousYear1={deliveryAverages && deliveryAverages[1]}
              previousYear2={deliveryAverages && deliveryAverages[2]}
              loading={loadingDeliveryAverages}
            />
          </div>

          {/**
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                <Grafico/>
                <Grafico/>
                <Grafico/>
                <Grafico/>
                <Grafico/>
                <Grafico/>
              </div>

               */}

          {/* Modal de Edición de Contacto */}
          {showContactModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="lg:w-[30%] md:w-[45%] w-[90%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-5  ">
                <div className='flex justify-end'>
                  <button
                    onClick={() => setShowContactModal(false)}
                    className="px-4 py-2 rounded-md"
                  >
                    <img src={MODALS.CLOSE} alt="cerrar"/>
                  </button>
                </div>
                <div className='flex flex-col items-center justify-center gap-3 px-10'>
                  <h3 className="text-sm md:text-lg font-itcdemi">Editar el número de contacto</h3>
                  <input
                    type="text"
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    className="w-full h-[37px] p-3 text-sm md:text-lg outline-none border border-[#D1D5DB] rounded-md font-itcbook"
                    maxLength="11" // 9 dígitos + 2 espacios
                  />
                </div>

                <button
                  onClick={handleSubmit}
                  className="pt-4 text-sm underline md:text-lg text-blue font-itcbook"
                >
                  Actualizar
                </button>
              </div>
            </div>
          )}

          <ModalSurveysCount
            showModalSurveysCount={showModalSurveysCount}
            closeModal={closeSurveysCountModal}
            countNotResponded={countNotResponded}
            userName={user?.name || ''}
          />

          <ModalRemainingDocuments
            showModalRemaining={showModalRemaining}
            closeModal={closeRemainingModal}
            seasonsLeft={seasonsLeft}
          />

          <ModalWarning
            showModalWarning={showModalWarning}
            closeModal={closeModal}
            isContrato={true}
          />

          <ModalWarning
            showModalWarning={showHomologationWarning && criticity == "Crítico"}
            closeModal={closeHomologationModal}
            daysLeft={daysLeft}
            isContrato={false}
          />

          <ModalSuccess
            showModalSuccess={showSuccessModal}
            closeModalSuccess={() => setShowSuccessModal(false)}
            fill="green"
            text="El número de contacto se actualizó correctamente"
          />
        </div>
      </div>

      {showAdModal && activeAds[currentAdIndex] && (
        <AdHomeModal
          isOpen={isAdOpen}
          activeAds={activeAds}
          currentAdIndex={currentAdIndex}
          onClose={handleClose}
        />
      )}

    </div >
  );
}